//MUI
import { Button, Tooltip } from "@mui/material"

//images
import addIcon from 'assets/images/admin/topic/icons/add-purple.svg'
import duplicateIcon from 'assets/images/admin/topic/icons/duplicate.svg'
import deleteIcon from 'assets/images/admin/topic/icons/delete.svg'

//providers
import { useTopicDataContext } from "../_providers/Topic"

//components
import MiniHeading from "./MiniHeading"
import MiniText from "./MiniText"
import MiniGallery from "./MiniGallery"

const Aside = () => {
    const topicData = useTopicDataContext()
    const {
        slides,
        handleSlide,
        isSlideDeletable,
        handleActiveTemplate,
        handleActiveSlide
    } = topicData

    const getTemplate = ({ heading, text, images }, i) => {
        switch (handleActiveTemplate()._get(i).type) {
            case 'heading-text':
                return <>
                    <MiniHeading heading={heading} />
                    <MiniText text={text} />
                </>

            case 'heading-images-text':
                return <>
                    <MiniHeading heading={heading} />
                    <MiniGallery images={images} />
                    <MiniText text={text} />
                </>

            case 'heading-image-text':
                return <>
                    <MiniGallery images={images} single={true} />
                    <div className="holder">
                        <MiniHeading heading={heading} />
                        <MiniText text={text} />
                    </div>
                </>

            case 'images-text':
                return <>
                    <MiniGallery images={images} />
                    <MiniText text={text} />
                </>

            case 'text':
                return <>
                    <MiniText text={text} />
                </>
        }
    }

    return (
        <div className="aside">
            <ul className="list">
                {slides.list.map((s, i) =>
                    <li
                        key={`slide-mini-${s.id}-${i}`}
                        className={handleActiveSlide()._get()._index() === i ? 'active' : ''}
                    >
                        <div
                            className="content"
                            onClick={() => {
                                handleActiveSlide()._set(i)
                            }}
                        >
                            <span className="number">
                                {i + 1}
                            </span>
                            <div className={`mini-content ${handleActiveTemplate()._get(i).type}`}>
                                {getTemplate(s.content, i)}
                            </div>
                            {/* {s.duplicated ? 'Дубликат' : 'Оригинал'} */}
                        </div>

                        <ul className="options">
                            <li className="duplicate">
                                <Tooltip title="Дублиране на слайда">
                                    <Button
                                        onClick={() => {
                                            handleSlide()._duplicate(i)
                                        }}
                                    >
                                        <img src={duplicateIcon} />
                                    </Button>
                                </Tooltip>
                            </li>
                            {isSlideDeletable() ?
                                <li className="delete">
                                    <Tooltip title="Премахване на слайд">
                                        <Button
                                            onClick={() => {
                                                handleSlide()._delete(i)
                                            }}
                                        >
                                            <img src={deleteIcon} />
                                        </Button>
                                    </Tooltip>
                                </li>
                                :
                                <>
                                </>
                            }
                        </ul>
                    </li>
                )}
            </ul>
            <Button
                className="new-slide"
                onClick={handleSlide()._add}
            >
                <img src={addIcon} />
                Нов слайд
            </Button>
        </div>
    )
}

export default Aside